import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import * as moment from 'moment';

import PageTitle from '~/components/PageTitle';
import { S_Btn_Search, S_DateInput, S_Title } from '~/components/SearchItem';
import SearchBar from '~/components/SearchBar';
import Actions_Wind_V2 from '~/Actions_Wind_V2';
import LoadingOverlay from '~/components/LoadingOverlay';

const styles = (theme) => ({
    root: {
    },
    list: {
        paddingLeft: 30,
    },
    sublist: {
        paddingLeft: 60,
    },
    highligh: {
        fontSize: 20,
        fontWeight: 'bold',
        color: 'red',
        paddingLeft: 3,
        paddingRight: 3,
    }
});

const Page_DailyStats = (props) => {
    const { t, classes } = props;
    const [searchDate, setSearchDate] = useState(new Date());
    const [isLoading, setLoading] = useState(false);
    const [stats, setStats] = useState({});

    const haveData = (stats?.date) ? true : false;

    useEffect(() => {
        
    }, []);

    const onClickSearch = () => {
        setLoading(true);

        if (searchDate) {
            console.log(searchDate);
            Actions_Wind_V2.Gis.getDailyPlanStats({
                date: moment(searchDate).format('YYYY-MM-DD'),
            }).then(res => {
                console.log('hi~', moment(searchDate).format('YYYY-MM-DD'), res);
                setStats(res);
            }).finally(() => {
                setLoading(false);
            });
        }
    }

    const renderTodayWorkingProgress = (nums, records = []) => {
        if (nums && records) {
            const { z3_have_done_num = 0, z4_have_done_num = 0 } = nums;
            return (
                <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                    <div className={classes.list}>
                    • {`本日共新增風力機安裝`} <span className={classes.highligh}>{z3_have_done_num}</span> {`座、併網`} <span className={classes.highligh}>{z4_have_done_num}</span> {`座`}
                    </div>
                    {renderTodayList(records, 'turbine')}
                    {renderTodayList(records, 'grid')}
                </div>
            )
        }
    };

    const renderTodayList = (records, type) => {
        if (type == 'turbine') {
            return (
                <>
                    {/* <S_Title text={`風力機:`} /> */}
                    {
                        records.map((r, rIdx) => {
                            const { wind_turbine_bases: sW = [], windcontract: { name: windField = ''} } = r;
                            if (sW.length > 0) {
                                return (
                                    sW.map((wr, wrIdx) => {
                                        return (
                                            <div className={classes.sublist} key={`WR-${wrIdx}`}>
                                            • {`本日 ${windField} 風場完成第`} <span className={classes.highligh}>{wr?.base_name || ''}</span> {`座 風力機安裝`}
                                            </div>
                                        )
                                    })
                                )
                            }
                            
                            // return (
                            //     <span key={`today-turbine-${rIdx}`}>
                            //         {
                            //             sW.length > 0 &&
                            //             sW.map((wr, wrIdx) => {
                            //                 return (
                            //                     <div className={classes.sublist} key={`WR-${wrIdx}`}>• {`本日 ${windField} 風場完成第`} <span className={classes.highligh}>{wr?.base_name || ''}</span> {`座 風力機安裝`}</div>
                            //                 )
                            //             })
                            //         }
                            //     </span>
                            // )
                        })
                    }
                </>
            );

        } else if (type == 'grid') {

            return (
                <>
                    {/* <S_Title text={`併網:`} /> */}
                    {
                        records.map((r, rIdx) => {
                            const { grid_connection_bases: sG = [], windcontract: { name: windField = ''} } = r;
                            if (sG.length > 0) {
                                return (
                                    sG.map((gr, grIdx) => {
                                        return (
                                            <div className={classes.sublist} key={`GR-${grIdx}`}>
                                            • {`本日 ${windField} 風場完成第`} <span className={classes.highligh}>{gr?.base_name || ''}</span> {`座 併網`}
                                            </div>
                                        )
                                    })
                                )
                            }
                            // return (
                            //     // // <span key={`today-grid-${rIdx}`}>
                            //     // //     {
                            //     // //         sG.length > 0 &&
                            //     // //         sG.map((gr, grIdx) => {
                            //     // //             return (
                            //     // //                 <div className={classes.sublist} key={`GR-${grIdx}`}>• {`本日 ${windField} 風場完成第`} <span className={classes.highligh}>{gr?.base_name || ''}</span> {`座 併網`}</div>
                            //     // //             )
                            //     // //         })
                            //     // //     }
                            //     // // </span>
                            // )
                        })
                    }
                </>
            );
        }
    };

    const renderPotentialSites = (sites) => {
        if (sites) {
            const { grid_connection: sG, wind_turbine: sW, total_power = 0 } = sites;
            return (
                <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                    {/* <S_Title text={`潛力場址統計:`} /> */}
                    {
                        sW &&
                        <div className={classes.list}>
                        • {`${sW?.description || '潛力場址-總累計風力機-電力統計值'}: 安裝`} <span className={classes.highligh}>{sW?.total_base_num || 0}</span> {`座(`} <span className={classes.highligh}>{sW?.total_power || 0}</span> {`MW)`}
                        </div>
                    }
                    {
                        sG &&
                        <div className={classes.list}>
                        • {`${sG?.description || '潛力場址-總累計併網-電力統計值'}: 安裝`} <span className={classes.highligh}>{sG?.total_base_num || 0}</span> {`座(`} <span className={classes.highligh}>{sG?.total_power || 0}</span> {`MW)`}
                        </div>
                    }
                </div>
            );
        }
    };

    const renderAllSites = (sites) => {
        if (sites) {
            const { grid_connection: sG, wind_turbine: sW, total_power = 0 } = sites;
            return (
                <>
                    <div style={{ marginTop: 10, marginBottom:10, display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                        <div className={classes.list}>
                        {/* • {`總累計統計: 累計發電量`} <span className={classes.highligh}>{total_power}</span> {`度`} */}
                        • {`總累計統計:`}
                        </div>
                        <div className={classes.sublist}>
                            {sW && <>• {`${sW?.description || '總累計風力機-電力統計值'}: 安裝`} <span className={classes.highligh}>{sW?.total_base_num || 0}</span> {`座 (`}<span className={classes.highligh}>{sW?.total_power || 0}</span> {`MW)`}</>}
                        </div>
                        <div className={classes.sublist}>
                            {sG && <>• {`${sG?.description || '總累計併網-電力統計值'}: 安裝`} <span className={classes.highligh}>{sG?.total_base_num || 0}</span> {`座 (`}<span className={classes.highligh}>{sG?.total_power || 0}</span> {`MW)`}</>}
                        </div>
                    </div>
                </>
            );
        }
    };

    return (
        <div style={{
            position: 'absolute',
            left: 13,
            right: 0,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            overflow: 'auto',
        }}>
            <PageTitle text='統計數據' />
            <div style={{ marginTop: 24, display: 'flex' }}>
                <div style={{ marginLeft: 16 }}>
                    <S_Title text='查詢日期' />
                    <S_DateInput value={searchDate} onChange={t => setSearchDate(t)} inputFormat='yyyy/MM/dd' placeholder='年 / 月 / 日' />
                </div>
                <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
                    <S_Btn_Search onClick={onClickSearch} />
                </div>
            </div>
            
            <SearchBar style={{ marginTop: 16, overflow: 'auto' }} text='工進(日)統計數據' defaultOpen>
                <div style={{ marginLeft: 52, marginRight: 52, marginTop: 20, marginBottom: 20, overflow: 'auto' }}>
                    <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)', overflow: 'auto' }}>
                        <Paper style={{ minHeight: 388, overflow: 'auto' }} variant="outlined">
                            {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
                            {
                                haveData && 
                                <>
                                    <div style={{ marginTop: 24, display: 'flex' }}>
                                        <div style={{ marginLeft: 16 }}>
                                            <S_Title text={`日期: ${stats?.date || ''}`} />
                                        </div>
                                    </div>
                                    <div>
                                    </div>
                                    {
                                        renderTodayWorkingProgress(stats?.zone_have_done_nums, stats?.windcontract_statistics_records)
                                    }
                                    <hr />
                                    {
                                        renderPotentialSites(stats?.potential_sites)
                                    }
                                    <hr />
                                    {
                                        renderAllSites(stats?.all_sites)
                                    }
                                </>
                            }
                        </Paper>
                    </div>
                </div>
            </SearchBar>

        </div>
    );    
};

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({  
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(Page_DailyStats);
